export default __webpack_public_path__ + "static/media/jai.c79f39db.svg";